import styled from 'shared/utils/styled';

import Stack from '@mui/material/Stack';

const FiltersBar = styled(Stack)(({ theme }) => ({
  display: 'flex',
  padding: 15,
  background: theme.palette.primary.main,
}));

export default FiltersBar;
